import { normalizePhoneNumberForInput } from '@/utils/phone/normalizePhoneNumberForInput';

export const addDefaultCountryCodeToPhoneNumber = (phoneNumber: string) =>
  normalizePhoneNumberForInput(phoneNumber);